module.exports = __webpack_public_path__ + "img/edit.28096497.svg";